module.exports = window.dnn.nodeModules.ReduxDevToolsDockMonitor;